<ng-container class="wrapper" *ngIf="siteMap">
  <neb-header __neb_ui_lit_component class="sticky-top"
    [useIsolatedBootstrapStyles]="true"
    [sitemap]="siteMap"
    [isAdminViewMode]="isAdminViewMode"
    [profile]="siteMap.user"
    [mcUnReadMessagesCount]="unreadMessageCount"
    [isMobileDevice]="false"
    (onLogOut)="logout()"
  ></neb-header>

  <gems-banner-alert 
    class="d-flex w-100 container"
    [banners]="banners"
  />

  <div id="content" class="d-flex f-1">
    <ng-content></ng-content>
  </div>
  
  <neb-footer __neb_ui_lit_component
    [useIsolatedBootstrapStyles]="true"
    [sitemap]="siteMap"
    [isMobileDevice]="false"
  >
  </neb-footer>
</ng-container>